import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { COE_UPDATES } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/coe/updates/new")({
  component: () => <DeptContentForm cfg={COE_UPDATES} />,
});
